import activitySaga from "@rentiohq/shared-frontend/dist/redux/activity/activity.saga";
import authSaga from "@rentiohq/shared-frontend/dist/redux/auth/auth.saga";
import brokerSaga from "@rentiohq/shared-frontend/dist/redux/broker/broker.saga";
import cardSaga from "@rentiohq/shared-frontend/dist/redux/card/card.saga";
import contactSaga from "@rentiohq/shared-frontend/dist/redux/contact/contact.saga";
import countSaga from "@rentiohq/shared-frontend/dist/redux/count/count.saga";
import employeeAccountSaga from "@rentiohq/shared-frontend/dist/redux/employeeAccount/employeeAccount.saga";
import expertInquirySaga from "@rentiohq/shared-frontend/dist/redux/expertInquiry/expertInquiry.saga";
import featureFlagSaga from "@rentiohq/shared-frontend/dist/redux/featureFlag/featureFlag.saga";
import invitesSaga from "@rentiohq/shared-frontend/dist/redux/invites/invites.saga";
import invoiceItemsSaga from "@rentiohq/shared-frontend/dist/redux/invoiceItem/invoiceItem.saga";
import notificationSaga from "@rentiohq/shared-frontend/dist/redux/notification/notification.saga";
import paymentSaga from "@rentiohq/shared-frontend/dist/redux/payment/payment.saga";
import propertySaga from "@rentiohq/shared-frontend/dist/redux/property/property.saga";
import rentDepositSaga from "@rentiohq/shared-frontend/dist/redux/rentDeposit/rentDeposit.saga";
import requirementsSaga from "@rentiohq/shared-frontend/dist/redux/requirements/requirements.saga";
import ServicesSaga from "@rentiohq/shared-frontend/dist/redux/services/services.saga";
import socketSaga from "@rentiohq/shared-frontend/dist/redux/socket/socket.saga";
import subscriptionSaga from "@rentiohq/shared-frontend/dist/redux/subscription/subscription.saga";
import templateSaga from "@rentiohq/shared-frontend/dist/redux/template/template.saga";
import { applicationFiltersModule } from "@rentiohq/shared-frontend/dist/reduxV2/applicationFilters";
import { applicationModule } from "@rentiohq/shared-frontend/dist/reduxV2/applications";
import { assetsModule as assetsModuleV2 } from "@rentiohq/shared-frontend/dist/reduxV2/assets";
import { authModule } from "@rentiohq/shared-frontend/dist/reduxV2/auth";
import { bankAccountModule } from "@rentiohq/shared-frontend/dist/reduxV2/bankAccount";
import { brokerModule } from "@rentiohq/shared-frontend/dist/reduxV2/broker";
import { cardModule as cardModuleV2 } from "@rentiohq/shared-frontend/dist/reduxV2/card";
import { chatModule } from "@rentiohq/shared-frontend/dist/reduxV2/chats";
import { contractModule } from "@rentiohq/shared-frontend/dist/reduxV2/contract";
import { costCenterModule } from "@rentiohq/shared-frontend/dist/reduxV2/costCenter";
import { documentPackageModule } from "@rentiohq/shared-frontend/dist/reduxV2/documentPackage";
import { documentModule } from "@rentiohq/shared-frontend/dist/reduxV2/documents";
import { enabledAccountModule } from "@rentiohq/shared-frontend/dist/reduxV2/enabledAccount";
import { exportFileModule } from "@rentiohq/shared-frontend/dist/reduxV2/exportFile";
import { externalActionModule } from "@rentiohq/shared-frontend/dist/reduxV2/externalAction";
import { generalLedgerAccountModule } from "@rentiohq/shared-frontend/dist/reduxV2/generalLedgerAccount";
import { insuranceModule } from "@rentiohq/shared-frontend/dist/reduxV2/insurance";
import { invoiceModule } from "@rentiohq/shared-frontend/dist/reduxV2/invoice";
import { legalCaseModule } from "@rentiohq/shared-frontend/dist/reduxV2/legalCase";
import { noteModule } from "@rentiohq/shared-frontend/dist/reduxV2/note";
import { payInModule } from "@rentiohq/shared-frontend/dist/reduxV2/payin";
import { paymentGroupModule } from "@rentiohq/shared-frontend/dist/reduxV2/paymentGroup";
import { paymentOrderModule } from "@rentiohq/shared-frontend/dist/reduxV2/paymentOrder";
import { paymentRequestModule } from "@rentiohq/shared-frontend/dist/reduxV2/paymentRequest";
import { preferenceModule } from "@rentiohq/shared-frontend/dist/reduxV2/preferences";
import { propertyModule } from "@rentiohq/shared-frontend/dist/reduxV2/property";
import { propertyAmenityModule } from "@rentiohq/shared-frontend/dist/reduxV2/propertyAmenity";
import { rentRegistrationModule } from "@rentiohq/shared-frontend/dist/reduxV2/rentRegistration";
import { rentRegistrationDocumentsModule } from "@rentiohq/shared-frontend/dist/reduxV2/rentRegistrationDocuments";
import { reportBeneficiaryModule } from "@rentiohq/shared-frontend/dist/reduxV2/reportBeneficiary";
import { systemModule } from "@rentiohq/shared-frontend/dist/reduxV2/system";
import { tagModule } from "@rentiohq/shared-frontend/dist/reduxV2/tag";
import { taskModule } from "@rentiohq/shared-frontend/dist/reduxV2/task";
import { templateModule } from "@rentiohq/shared-frontend/dist/reduxV2/template";
import { templateDocumentModule } from "@rentiohq/shared-frontend/dist/reduxV2/templateDocuments";
import announcementSaga from "@rentiohq/web-shared/dist/redux/announcement/announcement.saga";
import featureFlagLocalSaga from "@rentiohq/web-shared/dist/redux/featureFlag/featureFlag.saga";
import invoiceSaga from "@rentiohq/web-shared/dist/redux/invoice/invoice.saga";
import requirementsLocalSaga from "@rentiohq/web-shared/dist/redux/requirements/requirements.saga";
import socketLocalSaga from "@rentiohq/web-shared/dist/redux/socket/socket.saga";
import statsSaga from "@rentiohq/web-shared/dist/redux/stats/stats.saga";
import systemLocalSaga from "@rentiohq/web-shared/dist/redux/system/system.saga";
import { all, fork } from "redux-saga/effects";

export const rootSaga = function* () {
  yield all([
    fork(authModule.saga),
    fork(activitySaga),
    fork(applicationModule.saga),
    fork(applicationFiltersModule.saga),
    fork(authSaga),
    fork(bankAccountModule.saga),
    fork(brokerSaga),
    fork(brokerModule.saga),
    fork(cardSaga),
    fork(chatModule.saga),
    fork(contactSaga),
    fork(contractModule.saga),
    fork(costCenterModule.saga),
    fork(countSaga),
    fork(documentModule.saga),
    fork(documentPackageModule.saga),
    fork(employeeAccountSaga),
    fork(enabledAccountModule.saga),
    fork(expertInquirySaga),
    fork(exportFileModule.saga),
    fork(featureFlagLocalSaga),
    fork(featureFlagSaga),
    fork(generalLedgerAccountModule.saga),
    fork(invitesSaga),
    fork(invoiceItemsSaga),
    fork(invoiceModule.saga),
    fork(insuranceModule.saga),
    fork(legalCaseModule.saga),
    fork(noteModule.saga),
    fork(notificationSaga),
    fork(payInModule.saga),
    fork(paymentGroupModule.saga),
    fork(paymentOrderModule.saga),
    fork(paymentRequestModule.saga),
    fork(paymentSaga),
    fork(propertyModule.saga),
    fork(propertyAmenityModule.saga),
    fork(propertySaga),
    fork(rentRegistrationDocumentsModule.saga),
    fork(rentRegistrationModule.saga),
    fork(rentDepositSaga),
    fork(reportBeneficiaryModule.saga),
    fork(requirementsLocalSaga),
    fork(requirementsSaga),
    fork(socketLocalSaga),
    fork(socketSaga),
    fork(statsSaga),
    fork(subscriptionSaga),
    fork(systemLocalSaga),
    fork(tagModule.saga),
    fork(taskModule.saga),
    fork(templateDocumentModule.saga),
    fork(templateSaga),
    fork(templateModule.saga),
    fork(ServicesSaga),
    fork(announcementSaga),
    fork(invoiceSaga),
    fork(preferenceModule.saga),
    fork(assetsModuleV2.saga),
    fork(cardModuleV2.saga),
    fork(externalActionModule.saga),
    fork(systemModule.saga),
  ]);
};
